import {
  ORGANIZATION_TYPE_SUCCESS,
  ORGANIZATION_TYPE_FAILED,
  RESET_ORGANIZATION_TYPE,
  LOADING_ORGANIZATION_TYPE,
  NETWORK_ERROR_ORGANIZATION_TYPE,
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetOrganizationType = () => {
  return { type: RESET_ORGANIZATION_TYPE };
};

const getOrganizationType = (userData, authTokenIs) => async (dispatch) => {
  dispatch({ type: LOADING_ORGANIZATION_TYPE });
  await partnerServices
    .post("getOrganizationType", userData, { headers: { AuthToken: authTokenIs } })

    .then((res) => {
      switch (res.data.status) {
        case "success":
          dispatch(organizationTypesuccess(res.data));
          // history.push({ pathname: "/index/homepage" });
          break;
        default:
          dispatch(organizationTypefailed(res.data));
          break;
      }
    })
    .catch((err) => {
      dispatch({ type: NETWORK_ERROR_ORGANIZATION_TYPE, payload: err });
    });
};

function organizationTypesuccess(data) {
  return {
    type: ORGANIZATION_TYPE_SUCCESS,
    payload: data,
  };
}

function organizationTypefailed(data) {
  return {
    type: ORGANIZATION_TYPE_FAILED,
    payload: data,
  };
}

export { resetOrganizationType, getOrganizationType };
